import { render, staticRenderFns } from "./ManageRate.vue?vue&type=template&id=266f9412&scoped=true"
import script from "./ManageRate.vue?vue&type=script&lang=js"
export * from "./ManageRate.vue?vue&type=script&lang=js"
import style0 from "./ManageRate.vue?vue&type=style&index=0&id=266f9412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f9412",
  null
  
)

export default component.exports